import { render } from "./ShopHome.vue?vue&type=template&id=163911ff&scoped=true"
import script from "./ShopHome.vue?vue&type=script&lang=js"
export * from "./ShopHome.vue?vue&type=script&lang=js"

import "./ShopHome.vue?vue&type=style&index=0&id=163911ff&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-163911ff"]])

export default __exports__